interface LoaderProps {
  rows?: number;
  className?: string;
}

const Loader = ({ rows = 3, className = '' }: LoaderProps) => {
  return (
    <div className={`nova-skeleton-loader ${className}`} aria-label="Loading content" role="status">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="nova-skeleton-row" />
      ))}
    </div>
  );
};

export default Loader;
